import script from "./ActivityManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityManage.vue?vue&type=script&setup=true&lang=js"

import "./ActivityManage.vue?vue&type=style&index=0&id=58c9e743&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c9e743"]])

export default __exports__